import {Redirect} from "react-router-dom";
import Cookies from 'js-cookie';

export const ProtectRoutes = ({ children, ...rest }) => {
   // console.log("HERE: " + children);
   // console.log("Cookies: " + JSON.stringify(Cookies.get()));
   return Cookies.get('token') ? children : <Redirect to="/"/>
};